export default __webpack_public_path__ + "static/media/dash-board-image.c4cd350d.png";